<template>
  <div class="custom-button">
    <a
      :tabindex="tabIndex"
      :class="['btn', type, size, active, content, useContext]"
      v-on:keyup.enter="onEnter"
      @click="onClick"
    >
      <slot name="icon" v-if="content === 'icon-with-label'">
      </slot>
      <paragraph
        class="button-text"
        :type="'p'"
        :variation="size"
        v-html="text"
      >
      </paragraph>
    </a>
  </div>
</template>

<script>
import Paragraph from '~/components/shared/paragraph.vue';

export default {
    name: 'custom-button',
    components: { Paragraph },
    props: {
        type: {
            type: String,
            default: 'primary',
        },
        size: {
            type: String,
            default: 'button-medium',
        },
        text: {
            type: String,
            default: 'Button Text',
        },
        isActive: {
            type: Boolean,
            default: true,
        },
        tabIndex: {
            type: Number,
            default: 1,
        },
        content: {
            type: String,
        },
        useContext: {
            type: String,
        },
    },
    computed: {
        active() {
            return this.isActive ? 'active' : 'unclickable disabled';
        },
    },
    methods: {
        onClick() {
            this.$emit('click');
        },
        onEnter() {
            this.$emit('enter');
        },
    },
};
</script>

<style lang="scss">
@import "global/default";

.custom-button {
  &.btn-icon {
    .btn {
        &.icon-with-label {
            padding: 0.25rem 1rem;
        }
    }
  }
  .btn {
    padding: 4px 16px;

    .button-text {
      margin-bottom: 0;
    }

    // type

    &.primary {
      background-color: $color-primary-300;
      border-color: $color-primary-300;

      .button-text {
        color: $color-neutral-light-100;
      }

      &:hover {
        background-color: $color-primary-400;
        border-color: $color-primary-400;
      }

      &:active {
        background-color: $color-primary-500;
        border-color: $color-primary-500;
        box-shadow: none !important;
      }
    }

    &.secondary {
      background-color: $color-secondary-300;
      border-color: $color-secondary-300;

      .button-text {
        color: $color-neutral-light-100;
      }

      &:hover {
        background-color: $color-secondary-400;
        border-color: $color-secondary-400;
      }

      &:active {
        background-color: $color-secondary-500;
        border-color: $color-secondary-500;
        box-shadow: none !important;
      }
    }

    &.achromatic-dark {
      background-color: $color-neutral-dark-400;
      border-color: $color-neutral-dark-400;

      .button-text {
        color: $color-neutral-light-100;
      }

      &:hover {
        background-color: $color-neutral-dark-500;
        border-color: $color-neutral-dark-500;
      }

      &:active {
        background-color: $color-neutral-dark-500;
        border-color: $color-neutral-dark-500;
        box-shadow: none !important;
      }
    }

    &.achromatic-light {
      background-color: $color-neutral-light-100;
      border-color: $color-neutral-light-300;

      .button-text {
        color: $color-neutral-dark-300;
      }

      &:hover {
        background-color: $color-neutral-light-500;
      }

      &:active {
        background-color: $color-neutral-light-500;
        box-shadow: none !important;
      }
    }

    &.unclickable {
      background-color: $color-neutral-light-500;
      border-color: $color-neutral-light-500;
      cursor: not-allowed !important;

      .button-text {
        color: $color-neutral-dark-300;
      }

      &:hover {
        background-color: $color-neutral-light-500;
        border-color: $color-neutral-light-500;
      }

      &:active {
        background-color: $color-neutral-light-500;
        border-color: $color-neutral-light-500;
        box-shadow: none !important;
      }
    }

    // content

    &.icon-with-label {
      display: flex;
      justify-content: center;
      align-items: center;
      width: fit-content;
      padding-left: 0.6rem;
      padding-right: 0.6rem;
      padding-top: 0.08rem;
      padding-bottom: 0.08rem;

      .button-text {
        margin-left: 0.5rem;
      }
    }

    // useContext

    &.success {
      background-color: $color-green-5;
      border-color: $color-green-5;
      color: $color-neutral-light-100;

      &:hover {
        background-color: $color-green-5;
        border-color: $color-green-5;
      }

      &:active {
        background-color: $color-green-5;
        border-color: $color-green-5;
      }
    }

    &.cta {
      background-color: $color-gray-8;
      border-color: $color-gray-8;
      color: $color-neutral-light-100;

      &:hover {
        background-color: $color-gray-8;
        border-color: $color-gray-8;
      }

      &:active {
        background-color: $color-gray-8;
        border-color: $color-gray-8;
      }
    }

    &.info {
      background-color: $color-blue-6;
      border-color: $color-blue-6;
      color: $color-neutral-light-100;

      &:hover {
        background-color: $color-blue-6;
        border-color: $color-blue-6;
      }

      &:active {
        background-color: $color-blue-6;
        border-color: $color-blue-6;
      }
    }

    &.extra {
      background-color: $color-neutral-light-100;
      border-color: $color-blue-6;

      .button-text {
        color: $color-blue-6;
      }

      &:hover {
        background-color: $color-neutral-light-100;
        border-color: $color-blue-6;
      }

      &:active {
        background-color: $color-neutral-light-100;
        border-color: $color-blue-6;
      }

      &.disabled {
        background-color: $color-neutral-light-400;
      }
    }
  }
}
</style>
